import { useForm, Form } from "../../components/form/useForm";
import Input from "../../components/controls/Input";
import Select from "../../components/controls/Select";

import { Box } from "@mui/material";

import useStyles from "./editProfileStyle";
import { useTranslation } from "react-i18next";

import Button from "../../components/controls/Button";

import PageTitle from "../../components/pageTitle/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";

import ShowAlerts from "../../components/alert/Alert";
import { CountryList } from "../../utils/constants";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";

import globalStyles from "../../style/global.js";
import { editProfileData } from "../../redux/reduser/editProfile";

function EditProfile() {
  const classes = useStyles();
  const globalClasses = globalStyles();
  const { response, loading, error, errorMsg } = useSelector(
    (state) => state.editProfile
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const { t } = useTranslation();
  const genderItems = [
    { id: "male", title: "Male" },
    { id: "female", title: "Female" },
  ];

  const initialFValues = {
    firstName: "hussein",
    lastName: "ayyad",

    email: "husseinayyad@gmail.com",
    phone: "0795011274",
    country: "Jordan",

    gender: "Male",
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("firstName" in fieldValues)
      temp.firstName = fieldValues.firstName ? "" : t("required");
    if ("lastName" in fieldValues)
      temp.lastName = fieldValues.lastName ? "" : t("required");
    //   if ('userName' in fieldValues)
    //   temp.userName = fieldValues.userName ? "" :  t('required');
    if ("phone" in fieldValues)
      temp.phone = fieldValues.phone
        ? (temp.phone =
            /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
              fieldValues.phone
            )
              ? ""
              : t("invalidPhoneNumber"))
        : t("required");

    if ("gender" in fieldValues)
      temp.gender = fieldValues.gender ? "" : t("required");
    if ("country" in fieldValues)
      temp.country = fieldValues.country ? "" : t("required");
    if ("email" in fieldValues)
      temp.email = fieldValues.email
        ? (temp.email = /$^|.+@.+..+/.test(fieldValues.email)
            ? ""
            : t("invalidEmailAddress"))
        : t("required");

    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    window.scrollTo({ top: 0, behavior: "smooth" });
    if (validate()) {
      dispatch(editProfileData(values))
        .unwrap()
        .then(() => {
          if (!error) {
            //resetForm();
            setOpen(true);
          } else {
            setOpen(true);
          }
        })
        .catch(() => {
          setOpen(true);
        });
    }
  };

  return (
    <div >
   
      <ShowAlerts
        open={open}
        handleClose={handleClose}
        type={error ? "error" : "success"}
        msg={error ? errorMsg : response.message}
      />
      {loading ? (
        <div className={globalClasses.center}>
          <CircularProgressBar />
        </div>
      ) : null}
      <Form className={globalClasses.form}>
        <Box className={classes.box}>
          <Input
            name="firstName"
            label={t("firstName")}
            value={values.firstName}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.firstName}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            name="lastName"
            label={t("lastName")}
            value={values.lastName}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.lastName}
          />
        </Box>
        {/* <Box className={classes.box}>
                      <Input
                          name="userName"
                          label={t("userName")}
                          value={values.userName}
                          className={globalClasses.filed}
                          onChange={handleInputChange}
                          error={errors.userName}
                      />
                      </Box> */}
        <Box className={classes.box}>
          <Input
            name="email"
            label={t("email")}
            value={values.email}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            name="phone"
            className={globalClasses.filed}
            label={t("phone")}
            value={values.phone}
            onChange={handleInputChange}
            error={errors.phone}
          />
        </Box>

        <Box className={classes.box}>
          <Select
            className={globalClasses.filed}
            name="gender"
            label={t("gender")}
            value={values.gender}
            onChange={handleInputChange}
            error={errors.gender}
            options={[t("male"), t("female")]}
          />
        </Box>
        <Box className={classes.box}>
          <Select
            className={globalClasses.filed}
            name="country"
            label={t("country")}
            value={values.country}
            onChange={handleInputChange}
            options={CountryList}
            error={errors.country}
          />
        </Box>
        <Box>
          <Button
            className={globalClasses.btn}
            fullWidth="200px"
         
            color="primary"
            disabled={loading}
            onClick={resetForm}
            text={t("reset")}
          />
        </Box>
        <Box>
          <Button
            className={globalClasses.btn}
            fullWidth="200px"
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={handleSubmit}
            type="submit"
            text={t("update")}
          />
        </Box>

      
      </Form>
    </div>
  );
}

export default EditProfile;
